import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import { IoMdAnalytics, IoMdCheckmarkCircleOutline, IoMdClipboard, IoMdPie, IoMdSpeedometer } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				<div className="container">
					<h2 
						className="main-section-title"
					>
						Our Past Experiences
					</h2>
					<p className="text-muted mb-5">
						Showcasing projects and engagements that demonstrate our expertise across sectors and industries.
					</p>

					<div className="row g-4">
						<div className="col-12 col-md-6 col-lg-4">
						<div className="card h-100 shadow-sm">
							<div className="card-body">
							<h5 className="card-title font-bold">TCCP Baseline Survey</h5>
							<p className="card-text text-muted">
								Conducted baseline survey (July 2011) across 16 regions covering 4000 households. Focus areas included HIV/AIDS, Family Planning, Maternal & Child Health, OVC, and Male Circumcision.
							</p>
							</div>
							<div className="card-footer bg-transparent border-top-0">
							<small className="text-muted">July 2011</small>
							</div>
						</div>
						</div>

						<div className="col-12 col-md-6 col-lg-4">
						<div className="card h-100 shadow-sm">
							<div className="card-body">
							<h5 className="card-title font-bold">Monitoring & Evaluation Projects</h5>
							<p className="card-text text-muted">
								Implemented monitoring and evaluation projects for multiple sectors, providing data-driven insights for program improvement and impact assessment.
							</p>
							</div>
							<div className="card-footer bg-transparent border-top-0">
							<small className="text-muted">2015 – 2022</small>
							</div>
						</div>
						</div>

						<div className="col-12 col-md-6 col-lg-4">
						<div className="card h-100 shadow-sm">
							<div className="card-body">
							<h5 className="card-title font-bold">Data Analytics & Research</h5>
							<p className="card-text text-muted">
								Provided comprehensive data analytics, surveys, and research services for organizations, supporting evidence-based decision-making and strategic planning.
							</p>
							</div>
							<div className="card-footer bg-transparent border-top-0">
							<small className="text-muted">2013 – Present</small>
							</div>
						</div>
						</div>

						<div className="col-12 col-md-6 col-lg-4">
						<div className="card h-100 shadow-sm">
							<div className="card-body">
							<h5 className="card-title font-bold">Training & Capacity Building</h5>
							<p className="card-text text-muted">
								Delivered training and capacity-building programs to strengthen organizational capabilities in data management, project implementation, and decision-making.
							</p>
							</div>
							<div className="card-footer bg-transparent border-top-0">
							<small className="text-muted">2014 – Present</small>
							</div>
						</div>
						</div>

						<div className="col-12 col-md-6 col-lg-4">
						<div className="card h-100 shadow-sm">
							<div className="card-body">
							<h5 className="card-title font-bold">Consultancy Services</h5>
							<p className="card-text text-muted">
								Provided consultancy across sectors, including business advisory, project management, and financial management, helping clients achieve sustainable growth.
							</p>
							</div>
							<div className="card-footer bg-transparent border-top-0">
							<small className="text-muted">2012 – Present</small>
							</div>
						</div>
						</div>

						<div className="col-12 col-md-6 col-lg-4">
						<div className="card h-100 shadow-sm">
							<div className="card-body">
							<h5 className="card-title font-bold">OVC & Health Programs</h5>
							<p className="card-text text-muted">
								Supported Orphans and Vulnerable Children (OVC) and health-related programs, including maternal and child health initiatives, in collaboration with national and regional partners.
							</p>
							</div>
							<div className="card-footer bg-transparent border-top-0">
							<small className="text-muted">2011 – Present</small>
							</div>
						</div>
						</div>
					</div>
					</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
